import { MtUser } from "server/models"
import { OrderType } from "client/utils"
import { UserFilters } from "client/store"

export interface ProjectUserList { [projectId: number]: readonly number[]}

export interface ProjectUserState {
    projectUserList: ProjectUserList

    assignedUsers: {
        userIds: readonly number[]
        sortColumn: keyof MtUser
        sortOrder: OrderType
        filters: UserFilters
    }
    notAssignedUsers: {
        userIds: readonly number[]
        sortColumn: keyof MtUser
        sortOrder: OrderType
        filters: UserFilters
        selected: readonly number[]
    }

    reloadProjectUserList: boolean
}

export const PROJECT_USER_LIST = "PROJECT_USER_LIST"

export const ASSIGNED_PROJECT_USER_IDS = "ASSIGNED_PROJECT_USER_IDS"
export const ASSIGNED_PROJECT_USER_SORT = "ASSIGNED_PROJECT_USER_SORT"
export const ASSIGNED_PROJECT_USER_FILTERS = "ASSIGNED_PROJECT_USER_FILTERS"

export const NOT_ASSIGNED_PROJECT_USER_IDS = "NOT_ASSIGNED_PROJECT_USER_IDS"
export const NOT_ASSIGNED_PROJECT_USER_SORT = "NOT_ASSIGNED_PROJECT_USER_SORT"
export const NOT_ASSIGNED_PROJECT_USER_FILTERS = "NOT_ASSIGNED_PROJECT_USER_FILTERS"
export const NOT_ASSIGNED_PROJECT_USER_SELECTED = "NOT_ASSIGNED_PROJECT_USER_SELECTED"

export const PROJECT_USER_RELOAD_LIST = "PROJECT_USER_RELOAD_LIST"
